module.exports = __webpack_public_path__ + "img/logo1.cbbb6007.png";